var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationHomepage3Arrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.903,
    height: 74.69,
    viewBox: "0 0 83.903 74.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3100",
    "data-name": "Groupe 3100",
    transform: "translate(-1108.398 -1707.716)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_21",
    "data-name": "Union 21",
    d: "M194,78.568a25,25,0,0,1-25-25V34.342A25.006,25.006,0,0,1,190.015,9.658l6.452-5.78,5.972,5.464H227.9a25,25,0,0,1,25,25V53.568a25,25,0,0,1-25,25Z",
    transform: "translate(1361.302 1786.284) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M22.6,11.55a1.059,1.059,0,0,0-.008,1.491l4.927,4.935H7.1a1.054,1.054,0,0,0,0,2.107H27.514l-4.927,4.935a1.067,1.067,0,0,0,.008,1.491,1.049,1.049,0,0,0,1.483-.008l6.677-6.726h0a1.183,1.183,0,0,0,.219-.332,1,1,0,0,0,.081-.405,1.056,1.056,0,0,0-.3-.737l-6.677-6.726A1.032,1.032,0,0,0,22.6,11.55Z",
    transform: "translate(1169.381 1723.506) rotate(90)",
    fill: "#00a3da",
    stroke: "#00a3da",
    strokeWidth: 0.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationHomepage3Arrow);
export default __webpack_public_path__ + "static/media/illustration-homepage-3-arrow.6489d3ccd5643e29162e0d3a39250941.svg";
export { ForwardRef as ReactComponent };